<!-- <ngx-ui-loader></ngx-ui-loader> -->
<ngx-spinner bdColor = "rgba(255,255,255,0.5)" size = "medium" color = "#3d1560" type = "ball-clip-rotate-multiple" [fullScreen] = "true"></ngx-spinner>
<router-outlet></router-outlet>